import { Component, OnInit } from '@angular/core';
import { PaymentFailureDto } from '../../../model/dto/PaymentFailureDto';
import { ApiService } from '../../../backend/api.service';

@Component({
  selector: 'systemcode-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.css']
})
export class PageNotFoundComponent implements OnInit {

  public notFoundData: PaymentFailureDto

  public constructor(public apiService: ApiService) { 
    
  }

  public ngOnInit() {
    this.apiService.getNotFoundData().subscribe((result: PaymentFailureDto)=> this.notFoundData = result);
  }

}
